<template>
  <v-card elevation="0">
    <v-card-title>
      <span class="text-h5 gray--text">{{ formTitle }}</span>
    </v-card-title>

    <v-card-text>
      <v-container fluid>
        <v-row dense align="center">
          <v-col cols="auto">
            <v-switch
              label="Dilatação"
              v-model="dilation"
              dense
              hide-details
              @change="changeDilation"
              class="mt-0"
            />
          </v-col>

          <v-col>
            <v-checkbox
              v-model="refract"
              label="Refração"
              class="mt-0"
              hide-details
              dense
              :disabled="!dilation"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-select
              v-model="medicineId"
              outlined
              dense
              label="Medicamento"
              :items="medicineList"
              item-text="name"
              item-value="id"
              :hide-details="errors.medicine === undefined"
              :error-messages="errors.medicine"
              background-color="white"
              @change="medicineChange"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-select
              v-model="applicationRouteId"
              outlined
              dense
              label="Via de aplicação"
              :items="applicationRoutes"
              item-text="name"
              item-value="id"
              :hide-details="errors.applicationRoute === undefined"
              :error-messages="errors.applicationRoute"
              @change="applicationSite = ''"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-select
              v-model="applicationSiteId"
              outlined
              dense
              label="Local"
              :items="therapyApplicationSites"
              item-text="name"
              item-value="id"
              :hide-details="errors.applicationSite === undefined"
              :error-messages="errors.applicationSite"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-select
              v-model="interval"
              outlined
              dense
              label="Intervalo"
              :items="intervals"
              item-text="name"
              item-value="value"
              :hide-details="errors.interval === undefined"
              :error-messages="errors.interval"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-select
              v-model="numberOfApplications"
              outlined
              dense
              label="N° de aplicações"
              :items="numberOfApplicationsArray"
              item-text="name"
              item-value="value"
              :hide-details="errors.numberOfApplications === undefined"
              :error-messages="errors.numberOfApplications"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="auto">
            <v-btn color="light-blue" dark @click="saveAttendanceTherapy">
              Salvar
            </v-btn>
          </v-col>

          <v-col cols="auto">
            <v-btn color="gray lighten-1" dark @click="close"> cancelar </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TemplateItemForm",
  props: {
    templateItem: Object,
    save: Function,
    close: Function,
    medicines: Array,
    formTitle: String,
  },
  data() {
    return {
      errors: {},
      intervals: [
        { name: "3 minutos", value: 3 },
        { name: "5 minutos", value: 5 },
        { name: "10 minutos", value: 10 },
        { name: "15 minutos", value: 15 },
        { name: "20 minutos", value: 20 },
        { name: "30 minutos", value: 30 },
        { name: "40 minutos", value: 40 },
        { name: "45 minutos", value: 45 },
        { name: "1 hora", value: 60 },
        { name: "2 horas", value: 120 },
        { name: "3 horas", value: 180 },
        { name: "4 horas", value: 240 },
        { name: "6 horas", value: 360 },
        { name: "8 horas", value: 420 },
        { name: "12 horas", value: 720 },
      ],
      numberOfApplicationsArray: [
        { name: "1 vez", value: 1 },
        { name: "2 vezes", value: 2 },
        { name: "3 vezes", value: 3 },
        { name: "4 vezes", value: 4 },
        { name: "5 vezes", value: 5 },
        { name: "6 vezes", value: 6 },
      ],
    };
  },
  mounted() {
    this.dilation = true;
    this.changeDilation();
  },
  computed: {
    medicineList() {
      if (this.dilation) {
        return this.lodash.filter(this.medicines, function (medicine) {
          return medicine.applicationRoutes
            .map((e) => e.name)
            .includes("uso ocular");
        });
      }

      return this.medicines;
    },
    medicine() {
      return this.lodash.find(this.medicineList, { id: this.medicineId });
    },
    applicationRoutes() {
      if (this.medicine) {
        return this.medicine.applicationRoutes;
      }

      return [];
    },
    applicationRoute() {
      return this.lodash.find(this.applicationRoutes, {
        id: this.applicationRouteId,
      });
    },
    therapyApplicationSites() {
      if (this.applicationRoute) {
        return this.applicationRoute.applicationSites;
      }
      return [];
    },
    dilation: {
      set(value) {
        this.templateItem.buildingInformation.dilation = value;
      },
      get() {
        return this.templateItem.buildingInformation.dilation;
      },
    },
    refract: {
      set(value) {
        this.templateItem.buildingInformation.refract = value;
      },
      get() {
        return this.templateItem.buildingInformation.refract;
      },
    },
    interval: {
      set(value) {
        this.templateItem.buildingInformation.interval = value;
      },
      get() {
        return this.templateItem.buildingInformation.interval;
      },
    },
    numberOfApplications: {
      set(value) {
        this.templateItem.buildingInformation.number_of_applications = value;
      },
      get() {
        return this.templateItem.buildingInformation.number_of_applications;
      },
    },
    medicineId: {
      set(value) {
        this.templateItem.buildingInformation.medicine_id = value;
      },
      get() {
        return this.templateItem.buildingInformation.medicine_id;
      },
    },
    applicationRouteId: {
      set(value) {
        this.templateItem.buildingInformation.medicine_application_route_id = value;
      },
      get() {
        return this.templateItem.buildingInformation
          .medicine_application_route_id;
      },
    },
    applicationSiteId: {
      set(value) {
        this.templateItem.buildingInformation.medicine_application_site_id = value;
      },
      get() {
        return this.templateItem.buildingInformation
          .medicine_application_site_id;
      },
    },
  },
  methods: {
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      if (!this.medicineId) {
        this.errors.medicine = errorMsg;
      }
      if (!this.applicationRouteId) {
        this.errors.applicationRoute = errorMsg;
      }
      if (!this.applicationSiteId) {
        this.errors.applicationSite = errorMsg;
      }
      if (!this.interval) {
        this.errors.interval = errorMsg;
      }
      if (!this.numberOfApplications) {
        this.errors.numberOfApplications = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
    saveAttendanceTherapy() {
      if (!this.validate()) return;

      this.save();
    },
    changeDilation() {
      this.refract = false;

      this.medicineId = "";
      this.applicationRouteId = "";
      this.applicationSiteId = "";
      this.interval = "";
      this.numberOfApplications = "";

      if (this.dilation) {
        this.interval = 5;
        this.numberOfApplications = 3;
      }
    },
    medicineChange() {
      this.applicationRouteId = "";
      this.applicationSiteId = "";

      if (this.dilation) {
        this.applicationRouteId = this.lodash.find(this.applicationRoutes, {
          name: "uso ocular",
        }).id;

        this.applicationSiteId = this.lodash.find(
          this.therapyApplicationSites,
          {
            name: "em ambos os olhos",
          }
        ).id;
      } else {
        if (this.applicationRoutes.length == 1) {
          this.applicationRouteId = this.lodash.first(
            this.applicationRoutes
          ).id;
        }

        if (this.therapyApplicationSites.length == 1) {
          this.applicationSiteId = this.lodash.first(
            this.therapyApplicationSites
          ).id;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
